import { ModalConfirmV2, ModalSizeVariants } from '@labrav/react-components'
import { Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faDeleteRight,
  faLaptop,
  faLaptopSlash,
} from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from '../ProductListingV2.styles'

type ProductListingConfirmModalsProps = {
  openUnpublishModal: boolean
  openDeleteModal: boolean
  openPublishModal: boolean
  onUnpublish: () => void
  onDelete: () => void
  onPublish: () => void
  onUnpublishDecline: () => void
  onDeleteDecline: () => void
  onPublishDecline: () => void
}

export const ProductListingConfirmModals = ({
  openUnpublishModal,
  openDeleteModal,
  openPublishModal,
  onUnpublish,
  onDelete,
  onPublish,
  onUnpublishDecline,
  onDeleteDecline,
  onPublishDecline,
}: ProductListingConfirmModalsProps) => {
  const { classes } = useStyles({})

  return (
    <>
      <ModalConfirmV2
        title={'Unpublish listing?'}
        description={
          <Typography className={classes.modalText}>
            <p> Are you sure you want to unpublish this listing?</p>
            <p>
              Once you unpublish, no new buyers will be able to see your listing
              inside AWS marketplace as it will be removed. Your current
              customers will continue paying you till their purchase ends
            </p>
            <p>
              You can choose to publish your listing back again at any point in
              time
            </p>
            <p>
              <span className={classes.nameBoldText}>Note: </span>
              You can keep creating Private Offers on your unpublished listings
              and sell your product.
            </p>
          </Typography>
        }
        open={openUnpublishModal}
        titleAcceptButton={'Unpublish'}
        onAccept={onUnpublish}
        onDecline={onUnpublishDecline}
        variant={ModalSizeVariants.small}
        icon={
          <FontAwesomeIcon icon={faLaptopSlash} className={classes.modalIcon} />
        }
        hideCancelIcon={false}
        hideCancelButton={false}
      />
      <ModalConfirmV2
        title={'Delete listing?'}
        description={
          <Typography className={classes.modalText}>
            <p>
              You will not be able to recover this listing or any information
              inside it once your listing is deleted.
            </p>
            <p> Are you sure you want to delete this listing?</p>
          </Typography>
        }
        open={openDeleteModal}
        titleAcceptButton={'Delete'}
        onAccept={onDelete}
        onDecline={onDeleteDecline}
        variant={ModalSizeVariants.small}
        icon={
          <FontAwesomeIcon icon={faDeleteRight} className={classes.modalIcon} />
        }
        hideCancelIcon={false}
        hideCancelButton={false}
      />
      <ModalConfirmV2
        title={'Publish listing?'}
        description={
          <Typography className={classes.modalText}>
            <p> Are you sure you want to Publish this listing?</p>
            <p>
              Your listing is being tested by AWS Marketplace team and it's
              important that any feedback provided by them has been taken into
              account. If the changes asked by AWS team are not made then your
              listing may be rejected.
            </p>
            <p>
              <span className={classes.nameBoldText}>Note: </span>
              Please ensure you work closely with the AWS team to give them
              access to your product and aid them in the testing process for
              quick approval.
            </p>
          </Typography>
        }
        open={openPublishModal}
        titleAcceptButton={'Publish'}
        onAccept={onPublish}
        onDecline={onPublishDecline}
        variant={ModalSizeVariants.small}
        icon={<FontAwesomeIcon icon={faLaptop} className={classes.modalIcon} />}
        hideCancelIcon={false}
        hideCancelButton={false}
      />
    </>
  )
}
